export type AskDynamoThoughtFrequency = "daily" | "three_times_weekly" | "weekly" | "off"

export const ASK_DYNAMO_THOUGHT_FREQUENCIES: {
  value: AskDynamoThoughtFrequency
  label: string
  scheduleCopy: string
}[] = [
  {
    value: "daily",
    label: "Daily",
    scheduleCopy: "You will receive a new thought every day.",
  },
  {
    value: "three_times_weekly",
    label: "Three times per week",
    scheduleCopy: "You will receive a new thought on Monday, Wednesday, and Friday.",
  },
  {
    value: "weekly",
    label: "Weekly",
    scheduleCopy: "You will receive a new thought once per week.",
  },
  {
    value: "off",
    label: "Off",
    scheduleCopy: "Ask Dynamo Thoughts are turned off.",
  },
]

export function thoughtFrequencyLabel(frequency: AskDynamoThoughtFrequency): string {
  return ASK_DYNAMO_THOUGHT_FREQUENCIES.find((f) => f.value === frequency)?.label ?? frequency
}

export function thoughtFrequencyScheduleCopy(frequency: AskDynamoThoughtFrequency): string {
  return (
    ASK_DYNAMO_THOUGHT_FREQUENCIES.find((f) => f.value === frequency)?.scheduleCopy ??
    "Manage your email preferences anytime."
  )
}
